export default __webpack_public_path__ + "static/media/google-play-store.829254d1.png";